import { z } from "zod";

// A configuracao precisa ocorrer antes da criacao do primeiro schema. Sem ela,
// o Zod testa suporte a JIT com `new Function`, bloqueado pela CSP do APP.
z.config({ jitless: true });

export { z };
